export enum Pages {
  SubmitInsurance = '/',
  VerifyPolicy = '/verify-policy',
  PaymentSelection = '/payment-selection',
  AutoPay = '/auto-pay',
  PaymentStatus = '/payment-status',
  UpdateEmail = '/update-email',
  Confirmation = '/confirmation',
  SorryPage = '/sorry',
  AlreadyPaid = '/already-paid',
  Maintenance = '/maintenance',
}
